import { FailedUserItemDTO } from '../dto/edit-users/change-users-details-response.dto'

export class EditUsersFailedError extends Error {
  constructor(public readonly failedUsers: FailedUserItemDTO[]) {
    super(failedUsers[0]?.reason ?? 'Failed to update user')
  }
}
